import dayjs from "dayjs";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  useBookingDispatch,
  useBookingState,
} from "../../hooks/useBookingState";
import { useMoney } from "../../hooks/useMoney";
import { useBroadwayAvailability } from "../../services/musicalService";
import { PA_NAME } from "../../types/product-attribute/product-attribute";
import { TimeSlotUtils } from "../../utils/TimeSlotUtils";
import CheckBox from "../Checkbox";
import { BookVal } from "../../utils/bookingUtils";
import { ProdAttrUtils } from "../../utils/productAttributeUtils";
export const useMusicalData = ({
  enabled,
  bookingAttributes,
  shouldCheckTimeSlot = false,
}: {
  enabled: boolean;
  bookingAttributes: BookingAttributeDTO[];
  shouldCheckTimeSlot?: boolean;
}) => {
  const currentBa = enabled
    ? bookingAttributes.find((x) =>
        PA_NAME.PARTY_3RD.includes(
          x.productAttribute.name as ProdAttrName3rdParty,
        ),
      )
    : undefined;
  const paId = currentBa?.productAttribute?.id;

  const date =
    bookingAttributes.find(
      (x) => x.productAttribute.name === "MUSICAL_CALENDAR",
    )?.value?.destDate ?? "";

  const timeSlot = shouldCheckTimeSlot
    ? (bookingAttributes.find(
        (x) => x.productAttribute.name === "MUSICAL_CALENDAR",
      )?.value?.destTimeslot ?? "")
    : "";

  const { data } = useBroadwayAvailability({
    paId,
    date: date ? dayjs(date, "YYYYMMDD").format("YYYY-MM-DD") : undefined,
  });

  const broadwayAvailability = (function () {
    if (shouldCheckTimeSlot && !timeSlot) {
      return [];
    }
    if (timeSlot) {
      return (
        data?.filter((x) => {
          return (
            timeSlot ===
            TimeSlotUtils.broadwayProductTime2Timeslot(x.ProductTime)
          );
        }) ?? []
      );
    }
    return data ?? [];
  })();

  return { paId, broadwayAvailability, currentBa, date, timeSlot };
};
export const ProdAttrOfMUSICAL: FC<ProdAttrPickerModeProps> = (props) => {
  const bookingDispatch = useBookingDispatch({ mode: "FORM" });
  const { t } = useTranslation();
  const bookingState = useBookingState(props);
  const bookingAttributes = bookingState.bookingAttributes;

  // const externalProductList = useExternalProductList({
  //   paId,
  // });
  // const listTicketoptions: TOptionProps<ExtProductDTO>[] = useMemo(() => {
  //   return (externalProductList.data ?? []).map((x) => {
  //     return {
  //       displayName: x.name,
  //       value: x,
  //     };
  //   });
  // }, [externalProductList]);
  const { currentBa, broadwayAvailability, date, timeSlot } = useMusicalData({
    enabled: true,
    bookingAttributes,
    shouldCheckTimeSlot: true,
  });

  const listTicketoptions: TOptionProps<ExtProductDTO>[] = useMemo(() => {
    return (broadwayAvailability ?? []).map((x) => {
      return {
        displayName: x.Description,
        value: {
          extProductId: x.ProductId + "",
          name: x.Description,
          price: x.Price,
          extProductType: "BROADWAY_TICKET",
          extProducts: [],
          extProductMeta: {},
        } as ExtProductDTO,
      };
    });
  }, [broadwayAvailability]);

  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const [selectedTicket, setSelectedTicket] = useState<ExtProductDTO | null>(
  //   null,
  // );

  // const handleSubmitModal = () => {
  //   setIsModalOpen(false);
  // };
  // Close modal
  return (
    <div className="mb-10">
      {JSON.stringify(broadwayAvailability?.map)}
      {/* {selectedTicket?.extProductId && (
        <ProdAttrOfMusicalSeat
          selectedTicket={selectedTicket}
          paId={paId}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSubmit={handleSubmitModal}
          mode={props.mode}
        />
      )} */}
      <CheckBox
        title={t("Ticket Type")}
        options={listTicketoptions}
        classNameProp={{ style: { fontSize: "0.875rem", width: "100%" } }}
        defaultSelected={
          listTicketoptions
            .filter((x) => {
              return !!bookingAttributes.find((y) =>
                y.value?.extProductBookingValues?.find(
                  (yy) => yy.extProductId === x.value.extProductId,
                ),
              );
            })
            .map((x) => x.value) as ExtProductDTO[]
        }
        maxSelectable={1}
        onSelect={(options) => {
          // if (options[0]?.value) {
          //   setSelectedTicket(options[0]?.value);
          // }
          // setIsModalOpen(true);

          const count = ProdAttrUtils.countPerson(bookingState);
          bookingDispatch.bookingPick(
            BookVal.overwrite(currentBa)({
              quantity: count,
              extProductBookingValues: options.map((option) => ({
                extProductId: option.value.extProductId,
                price: option.value.price,
                // *BOOKMARK*: cập nhật số lượng người cho MUSICAL
                quantity: count,
                destDate: date,
                destTimeslot: timeSlot,
                dpName: option.value.name,
              })),
            }),
          );
        }}
        children={(option) => <CheckBoxCustom {...option} />}
      />
    </div>
  );
};

const CheckBoxCustom = (option: OptionProps) => {
  const { formatMoney } = useMoney();

  return (
    <div className="flex">
      <div className="w-full border-r border-[#232323] text-left">
        {option.displayName}
      </div>
      <div className="my-auto w-[8.75rem]">
        {formatMoney(option.value.price)}
      </div>
    </div>
  );
};
